/* unplugin-vue-components disabled */import { render } from "./menuLeft.vue?vue&type=template&id=edf633ce&scoped=true"
import script from "./menuLeft.vue?vue&type=script&lang=js"
export * from "./menuLeft.vue?vue&type=script&lang=js"

import "./menuLeft.vue?vue&type=style&index=0&id=edf633ce&scoped=true&lang=css"
import "./menuLeft.vue?vue&type=style&index=1&id=edf633ce&lang=css"

import exportComponent from "D:\\un-app\\zsmy_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf633ce"]])

export default __exports__